module.exports = __webpack_public_path__ + "media/src/images/notice_summer-77c1eb94e9f1200189356146811edd69.svg";